import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Banner } from '@els/els-react--banner';
import { Modal } from '@els/els-react--modal';
import Header from './Header';

import QueryRow from './QueryRow';
import AlertNameRow from './AlertNameRow';
import SendAlertsToRow from './SendAlertsToRow';
import FrequencyRow from './FrequencyRow';
import TriggerModeRow from './TriggerModeRow';
import BasicContent from './BasicContent';
import AdvancedContent from './AdvancedContent';
import PreFooter from './PreFooter';
import Footer from './Footer';

import './AlertCreateDialog.scss';

export default function AlertCreateDialog(props) {
  const { className, alertsInfo, basicContentAvailable, isMigrateMode = false, isEditMode = false, selfClose = () => {} } = props;
  const titleId = 'alert-create-dialog-title';
  const isInitializing = !alertsInfo;

  let modalLabel = 'Create alert';
  if (isEditMode) {
    modalLabel = 'Edit alert';
  } else if (isMigrateMode) {
    modalLabel = 'Migrate alert';
  }

  return (
    <Modal
      id="alert-create-dialog"
      className={classnames([className, 'create-alert-dialog', { 'create-alert-dialog--initializing': isInitializing }])}
      label={modalLabel}
      width="42rem"
      shouldHideCloseButton
      onClose={selfClose}>
      <>
        <header className="create-alert-dialog-header">
          <Header {...props} id={titleId} />
        </header>
        <section className="create-alert-dialog-content-wrapper" aria-busy={isInitializing}>
          <Banner type="warn" isVisible={Boolean(isMigrateMode)} className="u-els-margin-bottom-1x">
            Upon migration, the previous alert results (shown in the Results from: dropdown menu) will be lost. Please ensure to review the
            results before completing the migration process.
          </Banner>
          <div className="sr-only">
            Set up email alerts for saved searches. Choose name, frequency, recipients, and alert content options.
          </div>
          <QueryRow {...props} />
          {alertsInfo && (
            <>
              <AlertNameRow {...props} />
              <SendAlertsToRow {...props} />
              <FrequencyRow {...props} />
              <TriggerModeRow {...props} />
              {basicContentAvailable && <BasicContent {...props} />}
              <AdvancedContent {...props} />
              <PreFooter {...props} />
            </>
          )}
        </section>
        <footer className="create-alert-dialog-footer">
          <Footer {...props} />
        </footer>
      </>
    </Modal>
  );
}

AlertCreateDialog.propTypes = {
  className: PropTypes.string,
  alertsInfo: PropTypes.object,
  basicContentAvailable: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
  selfClose: PropTypes.func,
};
